import React from 'react';
import { AchievementStats } from '../../types';

interface QuickActionsProps {
  healthMode: 'headaches' | 'tensions' | 'lloros';
  isExportingPDF: boolean;
  isExportingAnnualPDF: boolean;
  currentCalendarDate: Date;
  achievementStats: AchievementStats | null;
  onNewHeadache: () => void;
  onNewTension: () => void;
  onNewLloro: () => void;
  onExportPDF: () => void;
  onExportAnnualPDF: () => void;
  onExportTensionPDF: () => void;
  onExportTensionAnnualPDF: () => void;
  onOpenAchievements: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({
  healthMode,
  isExportingPDF,
  isExportingAnnualPDF,
  currentCalendarDate,
  achievementStats,
  onNewHeadache,
  onNewTension,
  onNewLloro,
  onExportPDF,
  onExportAnnualPDF,
  onExportTensionPDF,
  onExportTensionAnnualPDF,
  onOpenAchievements
}) => {
  if (healthMode === 'headaches') {
    return (
      <div className="quick-action-section">
        <button
          className="quick-action-btn"
          onClick={onNewHeadache}
        >
          <span className="btn-icon">➕</span>
          Registrar Nuevo Dolor de Cabeza
        </button>

        <button
          className="export-pdf-btn"
          onClick={onExportPDF}
          disabled={isExportingPDF}
        >
          <span className="btn-icon">📄</span>
          {isExportingPDF ? 'Generando PDF...' : `Exportar PDF de ${currentCalendarDate.toLocaleDateString('es-ES', { month: 'long' })}`}
        </button>

        <button
          className="annual-pdf-btn"
          onClick={onExportAnnualPDF}
          disabled={isExportingAnnualPDF}
        >
          <span className="btn-icon">📊</span>
          {isExportingAnnualPDF ? 'Generando...' : `Reporte Anual ${currentCalendarDate.getFullYear()}`}
        </button>
      </div>
    );
  }

  if (healthMode === 'tensions') {
    return (
      <div className="quick-action-section">
        <button
          className="quick-action-btn tension-btn"
          onClick={onNewTension}
        >
          <span className="btn-icon">➕</span>
          Registrar Nueva Tensión
        </button>

        <button
          className="export-pdf-btn"
          onClick={onExportTensionPDF}
          disabled={isExportingPDF}
        >
          <span className="btn-icon">📊</span>
          {isExportingPDF ? 'Generando PDF...' : 'Ver Historial de Tensiones'}
        </button>

        <button
          className="annual-pdf-btn"
          onClick={onExportTensionAnnualPDF}
          disabled={isExportingAnnualPDF}
        >
          <span className="btn-icon">📊</span>
          {isExportingAnnualPDF ? 'Generando...' : 'Reporte Anual de Tensiones'}
        </button>

        <button
          className="achievements-btn"
          onClick={onOpenAchievements}
          style={{
            background: 'linear-gradient(135deg, #f59e0b, #d97706)',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <span className="btn-icon">🏆</span>
          Logros
          {achievementStats && achievementStats.new_achievements > 0 && (
            <span
              className="achievement-badge"
              style={{
                position: 'absolute',
                top: '-5px',
                right: '-5px',
                background: '#ef4444',
                color: 'white',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                fontSize: '12px',
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                animation: 'pulse 2s infinite'
              }}
            >
              {achievementStats.new_achievements}
            </span>
          )}
        </button>
      </div>
    );
  }

  if (healthMode === 'lloros') {
    return (
      <div className="quick-action-section">
        <button
          className="quick-action-btn lloro-btn"
          onClick={onNewLloro}
        >
          <span className="btn-icon">➕</span>
          Registrar Nuevo Lloro
        </button>
      </div>
    );
  }

  return null;
};

export default QuickActions;
